import React, { useEffect, useState, createElement } from 'react';
import { Calendar, X, Download, Mail, MessageCircle, CheckCircle2, Clock, ArrowRight, Sparkles, Gift, Star, Users, Zap, AlertTriangle, Headphones, Video, DollarSign, ListChecks } from 'lucide-react';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
// Returns the next Thursday at 7PM America/New_York as a Date object (UTC instant)
function getNextThursdayDate() {
  const now = new Date();
  const estNow = new Date(now.toLocaleString('en-US', {
    timeZone: 'America/New_York'
  }));
  const currentDay = estNow.getDay();
  const currentHour = estNow.getHours();
  let daysUntilThursday = 0;
  if (currentDay === 4) {
    daysUntilThursday = currentHour >= 19 ? 7 : 0;
  } else if (currentDay < 4) {
    daysUntilThursday = 4 - currentDay;
  } else {
    daysUntilThursday = 7 - currentDay + 4;
  }
  const target = new Date(estNow);
  target.setDate(estNow.getDate() + daysUntilThursday);
  target.setHours(19, 0, 0, 0);
  const offsetDiff = now.getTime() - estNow.getTime();
  return new Date(target.getTime() + offsetDiff);
}
function formatThursdayLong(d: Date) {
  const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  const est = new Date(d.toLocaleString('en-US', {
    timeZone: 'America/New_York'
  }));
  return `${est.getDate()} de ${months[est.getMonth()]}`;
}
export function ConfirmationThankYouPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [targetDate] = useState<Date>(() => getNextThursdayDate());
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const tick = () => {
      const diff = targetDate.getTime() - new Date().getTime();
      if (diff <= 0) {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(diff / (1000 * 60 * 60) % 24);
      const minutes = Math.floor(diff / (1000 * 60) % 60);
      const seconds = Math.floor(diff / 1000 % 60);
      setTimeLeft({
        days,
        hours,
        minutes,
        seconds
      });
    };
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [targetDate]);
  const thursdayDay = (() => {
    const est = new Date(targetDate.toLocaleString('en-US', {
      timeZone: 'America/New_York'
    }));
    return est.getDate();
  })();
  const thursdayLong = formatThursdayLong(targetDate);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('init', '4285913388317138');
    window.fbq('track', 'PageView');
    (function (e: any, n: any, t: any, i: any, p: any, a: any, s: any) {
      e[i] || ((p = e[i] = function () {
        p.process ? p.process.apply(p, arguments) : p.queue.push(arguments);
      }).queue = []);
      p.t = +new Date();
      (a = n.createElement(t)).async = 1;
      a.src = 'https://static.newsbreak.com/business/tracking/nbpixel.js?t=' + 864e5 * Math.ceil(new Date().getTime() / 864e5);
      (s = n.getElementsByTagName(t)[0]).parentNode.insertBefore(a, s);
    })(window, document, 'script', 'nbpix', null, null, null);
    (window as any).nbpix('init', 'ID-2016254252686041090');
    (window as any).nbpix('event', 'view_content', {
      nb_value: 0
    });
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/nrxtdp5ht5.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    const style = document.createElement('style');
    style.textContent = `
      wistia-player[media-id='nrxtdp5ht5']:not(:defined) { 
        background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/nrxtdp5ht5/swatch'); 
        display: block; 
        filter: blur(5px); 
        padding-top:56.25%; 
      }
    `;
    document.head.appendChild(style);
    return () => {
      try {
        document.head.removeChild(playerScript);
        document.head.removeChild(embedScript);
        document.head.removeChild(style);
      } catch (e) {}
    };
  }, []);
  const testimonialVideos = [{
    id: '1192341590',
    title: 'Luis: $1,050 los primeros 7 días vendiendo 3 páginas web'
  }, {
    id: '1192341160',
    title: 'Noemi: Ya facturando $10,000 al mes desde su casa'
  }, {
    id: '1192341159',
    title: 'Mauricio: Más de $8,000 en páginas web vendidas en sus primeras 3 semanas'
  }];
  const whatsappBullets = ['Pantallazos REALES de alumnos cerrando clientes esta semana', 'Una preview exclusiva de la herramienta que vas a ver en vivo', 'Tips de preparación para que aproveches AL MÁXIMO la Masterclass', 'Recordatorios para que NO se te olvide (en una sola notificación)', 'Acceso prioritario al bonus de $297 si te quedas hasta el final'];
  const emailBullets = ['El link de Zoom para entrar el JUEVES 7PM Miami', 'Botón para agregar el evento a tu calendario (Google/Apple)', 'Instrucciones de cómo prepararte 10 minutos antes', 'Lo que vas a ver y aprender específicamente', 'Detalles del bonus de $297 que recibirás EN VIVO'];
  const guideBullets = ['Por qué el 9-5 está diseñado para mantenerte funcional, pero no libre.', 'La matemática real de por qué trabajar duro no siempre te hace avanzar.', 'La diferencia entre ingreso lineal e ingreso exponencial.', 'Cómo Andrés y María cambiaron de modelo y empezaron a ver otra posibilidad.', 'Las 5 habilidades que ya tienes y que pueden convertirse en tu ventaja.', 'Por qué ahora es el momento de aprender a construir con IA y sistemas digitales.', 'Cómo ver el sistema completo funcionando en una masterclass gratis.'];
  const bonusAudios = ['Audio 1 — Frecuencia Del Primer Movimiento', 'Audio 2 — Inmunidad Operativa', 'Audio 3 — Identidad Trascendente', 'Audio 4 — Visualización Pre-Operación', 'Audio 5 — Activación Energética'];
  const checklistItems = ['Paso 1 — Me uní al grupo de WhatsApp', 'Paso 2 — Encontré el email de Gabriel en mi inbox', 'Paso 3 — Descargué la guía "Cómo Escapar Del 9-5"', 'EXTRA — Agregué el evento a mi calendario', 'EXTRA — Le avisé a mi pareja/familia que estoy ocupado ese jueves 7-9 PM'];
  return <div className="min-h-screen bg-[#0a1428] text-white font-sans selection:bg-amber-400 selection:text-[#0a1428] overflow-x-hidden" data-id="element-1712">
      <noscript data-id="element-1713">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-1714" />
      </noscript>

      {/* Background Image Layer */}
      <div className="absolute top-0 left-0 w-full h-[320px] sm:h-[400px] md:h-[600px] z-0 opacity-60 pointer-events-none" data-id="element-1715">
        <img src="https://cdn.magicpatterns.com/uploads/owSR6X5Pw8KuRfkif7sGzk/6936d7f7169a421d1ba8a294.png" alt="Background Pattern" className="w-full h-full object-cover" style={{
        maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)'
      }} data-id="element-1716" />
      </div>

      {/* Ambient glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] md:w-[900px] h-[400px] md:h-[600px] bg-amber-500/[0.08] blur-[140px] rounded-full pointer-events-none" data-id="element-1717" />
      <div className="hidden md:block absolute top-[40%] right-0 w-[500px] h-[500px] bg-amber-400/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-1718" />
      <div className="hidden md:block absolute top-[10%] left-0 w-[400px] h-[400px] bg-blue-500/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-1719" />

      {/* Grid pattern */}
      <div className="absolute inset-0 opacity-[0.015] pointer-events-none" style={{
      backgroundImage: 'linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-1720" />

      {/* ============ TOP CONFIRMATION BANNER ============ */}
      <div className="relative z-10 bg-gradient-to-r from-emerald-500 to-emerald-600 py-2 sm:py-2.5 md:py-3.5 px-3 sm:px-4 border-b border-emerald-400/40" data-id="element-1721">
        <div className="max-w-5xl mx-auto text-center" data-id="element-1722">
          <div className="flex items-center justify-center gap-1.5 sm:gap-2 md:gap-3" data-id="element-1723">
            <CheckCircle2 className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-5 md:h-5 text-white flex-shrink-0" data-id="element-1724" />
            <span className="text-[10px] sm:text-xs md:text-sm lg:text-base font-black uppercase tracking-tight text-white leading-tight" data-id="element-1725">
              ¡Cupo Reservado! Bienvenido A La Masterclass Del Jueves 7PM Miami
            </span>
          </div>
        </div>
      </div>

      {/* ============ DATE BAR ============ */}
      <div className="relative z-10 bg-gradient-to-r from-amber-400 to-amber-500 py-2 sm:py-2.5 md:py-3.5 px-3 sm:px-4" data-id="element-1726">
        <div className="max-w-5xl mx-auto text-center" data-id="element-1727">
          <div className="flex items-center justify-center gap-1.5 sm:gap-2 md:gap-3" data-id="element-1728">
            <Calendar className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-5 md:h-5 text-[#0a1428] flex-shrink-0" data-id="element-1729" />
            <h1 className="text-[10px] sm:text-xs md:text-sm lg:text-base font-black uppercase tracking-tight text-[#0a1428] leading-tight" data-id="element-1730">
              Reservada La Fecha: Jueves {thursdayDay} · 7PM EST (Hora Miami)
            </h1>
          </div>
        </div>
      </div>

      {/* ============ MAIN CONTENT ============ */}
      <main className="relative z-10 max-w-6xl mx-auto px-4 sm:px-5 md:px-6 lg:px-8 py-8 sm:py-10 md:py-14 lg:py-20" data-id="element-1731">
        {/* ============ HERO / VSL ============ */}
        <section className="text-center mb-10 sm:mb-12 md:mb-16 lg:mb-20" data-id="element-1732">
          <div className="inline-flex items-center gap-1.5 sm:gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-3 sm:px-4 py-1 sm:py-1.5 mb-4 sm:mb-5 md:mb-7" data-id="element-1733">
            <Zap className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-amber-400 flex-shrink-0" data-id="element-1734" />
            <span className="text-amber-400 text-[9px] sm:text-[10px] md:text-xs font-black uppercase tracking-[0.16em] sm:tracking-[0.18em] leading-none" data-id="element-1735">
              Solo Te Quedan 3 Pasos Para Garantizar Tu Lugar
            </span>
          </div>

          <h2 className="text-[1.5rem] sm:text-[1.75rem] md:text-4xl lg:text-5xl xl:text-6xl font-black leading-[1.05] tracking-tight mb-3 sm:mb-4 md:mb-5 max-w-4xl mx-auto px-1" data-id="element-1736">
            ¡Estás Dentro!
            <br data-id="element-1737" />
            Ahora Mira Este Video Y{' '}
            <span className="relative inline-block" data-id="element-1738">
              <span className="relative z-10 text-amber-400" data-id="element-1739">
                Sigue Los 3 Pasos
              </span>
              <span className="absolute bottom-1 left-0 w-full h-2.5 md:h-3 bg-amber-400/15 -z-0 rounded-sm" data-id="element-1740" />
            </span>
          </h2>

          <p className="text-[13px] sm:text-sm md:text-lg lg:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed mb-6 sm:mb-8 md:mb-10 px-1" data-id="element-1741">
            Tu cupo está reservado, pero{' '}
            <span className="text-white font-bold" data-id="element-1742">
              NO estás 100% confirmado todavía
            </span>
            . Mira este video corto y completa los 3 pasos para asegurarte de NO
            perderte la Masterclass + el bonus de{' '}
            <span className="text-amber-400 font-bold" data-id="element-1743">$297</span>.
          </p>

          {/* VSL Player */}
          <div className="max-w-4xl mx-auto" data-id="element-1744">
            <div className="w-full overflow-hidden rounded-xl sm:rounded-2xl border-2 border-amber-500/30 bg-[#0f1b35]" style={{
            boxShadow: '0 0 50px rgba(245, 158, 11, 0.15), 0 20px 60px -20px rgba(0,0,0,0.65)'
          }} data-id="element-1745">
              {/* @ts-expect-error custom element */}
              <wistia-player media-id="nrxtdp5ht5" aspect="1.7777777777777777" data-id="element-1746"></wistia-player>
            </div>

            <div className="mt-4 sm:mt-5 md:mt-6 flex items-start gap-2.5 sm:gap-3 bg-red-500/10 border border-red-500/30 rounded-xl px-3 sm:px-4 py-2.5 sm:py-3 md:py-3.5 text-left" data-id="element-1747">
              <AlertTriangle className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-1748" />
              <p className="text-[12px] sm:text-sm md:text-base text-red-100 leading-snug" data-id="element-1749">
                <span className="font-black text-red-400" data-id="element-1750">
                  NO cierres esta página.
                </span>{' '}
                Completa los 3 pasos abajo AHORA — toma menos de 2 minutos.
              </p>
            </div>
          </div>
        </section>

        {/* ============ THE 3 STEPS ============ */}
        <section className="mb-12 sm:mb-14 md:mb-20 lg:mb-24" data-id="element-1751">
          <div className="text-center mb-8 sm:mb-10 md:mb-12" data-id="element-1752">
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-black leading-tight px-1" data-id="element-1753">
              Completa Estos{' '}
              <span className="text-amber-400" data-id="element-1754">3 Pasos AHORA</span>
              <br data-id="element-1755" />
              <span className="text-gray-300 font-bold text-base sm:text-lg md:text-2xl lg:text-3xl" data-id="element-1756">
                Para Garantizar Tu Cupo
              </span>
            </h2>
          </div>

          {/* ========= STEP 1 — WHATSAPP ========= */}
          <div className="max-w-4xl mx-auto mb-7 sm:mb-8 md:mb-10" data-id="element-1757">
            <div className="relative bg-gradient-to-br from-[#25D366]/12 to-[#128C7E]/8 border-2 border-[#25D366]/40 rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-7 lg:p-8 shadow-[0_0_40px_rgba(37,211,102,0.12)]" data-id="element-1758">
              <div className="absolute -top-3 -left-1.5 sm:-top-4 sm:-left-2 md:-top-5 md:-left-3" data-id="element-1759">
                <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 rounded-xl sm:rounded-2xl bg-[#25D366] flex items-center justify-center shadow-[0_8px_24px_-6px_rgba(37,211,102,0.7)]" data-id="element-1760">
                  <span className="text-white text-lg sm:text-xl md:text-2xl font-black leading-none" data-id="element-1761">
                    1
                  </span>
                </div>
              </div>

              <div className="pt-3 sm:pt-4 md:pt-2" data-id="element-1762">
                <h3 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-black text-white leading-tight mb-2" data-id="element-1763">
                  Únete A La Comunidad De WhatsApp
                </h3>
                <p className="text-[13px] sm:text-sm md:text-base text-[#25D366] font-bold mb-4 sm:mb-5 flex items-start gap-2" data-id="element-1764">
                  <MessageCircle className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0 mt-0.5" data-id="element-1765" />
                  <span data-id="element-1766">
                    Donde voy a compartir info IMPORTANTE antes de la
                    Masterclass
                  </span>
                </p>

                <p className="text-[13px] sm:text-sm md:text-base text-gray-300 leading-relaxed mb-3 sm:mb-4" data-id="element-1767">
                  En las próximas 48 horas voy a compartir{' '}
                  <span className="text-white font-bold" data-id="element-1768">EXCLUSIVAMENTE</span>{' '}
                  en este grupo de WhatsApp:
                </p>

                <ul className="space-y-2 sm:space-y-2.5 mb-5 sm:mb-6" data-id="element-1769">
                  {whatsappBullets.map((b, i) => <li key={i} className="flex items-start gap-2.5 sm:gap-3" data-id="element-1770">
                      <div className="w-4 h-4 sm:w-5 sm:h-5 rounded-full bg-[#25D366]/20 border border-[#25D366]/40 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1771">
                        <CheckCircle2 className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-[#25D366]" data-id="element-1772" />
                      </div>
                      <span className="text-[13px] sm:text-sm md:text-base text-gray-200 leading-snug" data-id="element-1773">
                        {b}
                      </span>
                    </li>)}
                </ul>

                <div className="flex items-start gap-2.5 sm:gap-3 bg-amber-500/10 border border-amber-500/30 rounded-xl px-3 sm:px-4 py-2.5 sm:py-3 mb-5 sm:mb-6" data-id="element-1774">
                  <AlertTriangle className="w-4 h-4 sm:w-5 sm:h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-1775" />
                  <p className="text-[12px] sm:text-xs md:text-sm text-amber-100 leading-snug" data-id="element-1776">
                    Esta información{' '}
                    <span className="font-black" data-id="element-1777">
                      NO la voy a mandar por email
                    </span>
                    . Solo en el grupo de WhatsApp. Si NO te unes, te lo
                    pierdes.
                  </p>
                </div>

                <a href="https://chat.whatsapp.com/CxQPcrB8ZuiFLvBx3MEsen" target="_blank" rel="noopener noreferrer" className="group w-full bg-[#25D366] hover:bg-[#1da851] text-white font-black text-[13px] sm:text-sm md:text-base lg:text-lg uppercase tracking-tight rounded-xl py-3.5 sm:py-4 md:py-5 px-3 sm:px-4 transition-all duration-300 flex items-center justify-center gap-2 sm:gap-2.5 shadow-[0_10px_30px_-10px_rgba(37,211,102,0.6)] hover:shadow-[0_10px_30px_-5px_rgba(37,211,102,0.8)] transform hover:scale-[1.02]" data-id="element-1778">
                  <MessageCircle className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" data-id="element-1779" />
                  <span data-id="element-1780">Unirme Al Grupo De WhatsApp</span>
                  <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" data-id="element-1781" />
                </a>

                <div className="mt-3 sm:mt-4 flex flex-wrap items-center justify-center gap-x-3 sm:gap-x-4 gap-y-1.5 text-[10px] sm:text-[11px] md:text-xs text-gray-400" data-id="element-1782">
                  <span className="flex items-center gap-1" data-id="element-1783">
                    <CheckCircle2 className="w-3 h-3 text-[#25D366]" data-id="element-1784" /> Privado
                  </span>
                  <span className="flex items-center gap-1" data-id="element-1785">
                    <CheckCircle2 className="w-3 h-3 text-[#25D366]" data-id="element-1786" /> Solo
                    mensajes importantes
                  </span>
                  <span className="flex items-center gap-1" data-id="element-1787">
                    <CheckCircle2 className="w-3 h-3 text-[#25D366]" data-id="element-1788" /> Puedes
                    salir cuando quieras
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* ========= STEP 2 — EMAIL ========= */}
          <div className="max-w-4xl mx-auto mb-7 sm:mb-8 md:mb-10" data-id="element-1789">
            <div className="relative bg-gradient-to-br from-amber-500/12 to-amber-600/8 border-2 border-amber-500/40 rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-7 lg:p-8 shadow-[0_0_40px_rgba(245,158,11,0.12)]" data-id="element-1790">
              <div className="absolute -top-3 -left-1.5 sm:-top-4 sm:-left-2 md:-top-5 md:-left-3" data-id="element-1791">
                <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 rounded-xl sm:rounded-2xl bg-amber-400 flex items-center justify-center shadow-[0_8px_24px_-6px_rgba(245,158,11,0.7)]" data-id="element-1792">
                  <span className="text-[#0a1428] text-lg sm:text-xl md:text-2xl font-black leading-none" data-id="element-1793">
                    2
                  </span>
                </div>
              </div>

              <div className="pt-3 sm:pt-4 md:pt-2" data-id="element-1794">
                <h3 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-black text-white leading-tight mb-2" data-id="element-1795">
                  Revisa Tu Email Con Los Detalles Del Evento
                </h3>
                <p className="text-[13px] sm:text-sm md:text-base text-amber-400 font-bold mb-4 sm:mb-5 flex items-start gap-2" data-id="element-1796">
                  <Mail className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0 mt-0.5" data-id="element-1797" />
                  <span data-id="element-1798">
                    Acabamos de mandarte un email con TODO lo que necesitas
                    saber
                  </span>
                </p>

                <p className="text-[13px] sm:text-sm md:text-base text-gray-300 leading-relaxed mb-3 sm:mb-4" data-id="element-1799">
                  En el email que acabamos de mandar a tu correo vas a
                  encontrar:
                </p>

                <ul className="space-y-2 sm:space-y-2.5 mb-5 sm:mb-6" data-id="element-1800">
                  {emailBullets.map((b, i) => <li key={i} className="flex items-start gap-2.5 sm:gap-3" data-id="element-1801">
                      <div className="w-4 h-4 sm:w-5 sm:h-5 rounded-full bg-amber-500/20 border border-amber-500/40 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1802">
                        <CheckCircle2 className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-amber-400" data-id="element-1803" />
                      </div>
                      <span className="text-[13px] sm:text-sm md:text-base text-gray-200 leading-snug" data-id="element-1804">
                        {b}
                      </span>
                    </li>)}
                </ul>

                <div className="flex items-start gap-2.5 sm:gap-3 bg-red-500/10 border border-red-500/30 rounded-xl px-3 sm:px-4 py-2.5 sm:py-3 mb-4 sm:mb-5" data-id="element-1805">
                  <AlertTriangle className="w-4 h-4 sm:w-5 sm:h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-1806" />
                  <p className="text-[12px] sm:text-xs md:text-sm text-red-100 leading-snug" data-id="element-1807">
                    <span className="font-black" data-id="element-1808">IMPORTANTE:</span> El email
                    puede tardar 2-5 minutos en llegar. Si NO lo ves en tu
                    inbox, revisa la carpeta de{' '}
                    <span className="font-bold" data-id="element-1809">SPAM o PROMOCIONES</span> y
                    márcalo como "NO es spam" para asegurar futuros
                    recordatorios.
                  </p>
                </div>

                <div className="bg-white/[0.03] border border-white/[0.08] rounded-xl px-3 sm:px-4 py-3 sm:py-3.5 mb-5 sm:mb-6 space-y-1.5" data-id="element-1810">
                  <p className="text-[12px] sm:text-xs md:text-sm text-gray-400 break-words" data-id="element-1811">
                    <span className="text-gray-200 font-bold" data-id="element-1812">
                      De qué correo viene:
                    </span>{' '}
                    <span className="text-amber-400" data-id="element-1813">
                      gabriel@aiwebcloser.com
                    </span>
                  </p>
                  <p className="text-[12px] sm:text-xs md:text-sm text-gray-400" data-id="element-1814">
                    <span className="text-gray-200 font-bold" data-id="element-1815">
                      Subject del email:
                    </span>{' '}
                    <span className="text-amber-400" data-id="element-1816">
                      "Confirmado — Detalles De Tu Masterclass"
                    </span>
                  </p>
                </div>

                <a href="https://mail.google.com" target="_blank" rel="noopener noreferrer" className="group w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-[13px] sm:text-sm md:text-base lg:text-lg uppercase tracking-tight rounded-xl py-3.5 sm:py-4 md:py-5 px-3 sm:px-4 transition-all duration-300 flex items-center justify-center gap-2 sm:gap-2.5 shadow-[0_10px_30px_-10px_rgba(245,158,11,0.6)] hover:shadow-[0_10px_30px_-5px_rgba(245,158,11,0.8)] transform hover:scale-[1.02]" data-id="element-1817">
                  <Mail className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" data-id="element-1818" />
                  <span data-id="element-1819">Abrir Mi Email Ahora</span>
                  <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" data-id="element-1820" />
                </a>

                <p className="mt-3 text-center text-[10px] sm:text-[11px] md:text-xs text-gray-400 leading-snug" data-id="element-1821">
                  Tip: márcame como "Importante" o agrégame a contactos para que
                  todos los recordatorios lleguen a inbox.
                </p>
              </div>
            </div>
          </div>

          {/* ========= STEP 3 — DOWNLOAD GUIDE ========= */}
          <div className="max-w-4xl mx-auto" data-id="element-1822">
            <div className="relative bg-gradient-to-br from-amber-500/12 to-amber-600/8 border-2 border-amber-500/40 rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-7 lg:p-8 shadow-[0_0_40px_rgba(245,158,11,0.12)]" data-id="element-1823">
              <div className="absolute -top-3 -left-1.5 sm:-top-4 sm:-left-2 md:-top-5 md:-left-3" data-id="element-1824">
                <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 rounded-xl sm:rounded-2xl bg-amber-400 flex items-center justify-center shadow-[0_8px_24px_-6px_rgba(245,158,11,0.7)]" data-id="element-1825">
                  <span className="text-[#0a1428] text-lg sm:text-xl md:text-2xl font-black leading-none" data-id="element-1826">
                    3
                  </span>
                </div>
              </div>

              <div className="pt-3 sm:pt-4 md:pt-2" data-id="element-1827">
                <h3 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-black text-white leading-tight mb-2" data-id="element-1828">
                  Descarga La Guía Gratis Para Prepararte
                </h3>
                <p className="text-[13px] sm:text-sm md:text-base text-amber-400 font-bold mb-4 sm:mb-5 flex items-start gap-2" data-id="element-1829">
                  <Download className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0 mt-0.5" data-id="element-1830" />
                  <span data-id="element-1831">
                    Léela ANTES de la Masterclass para llegar 10x mejor
                    preparado
                  </span>
                </p>

                <div className="mb-4 sm:mb-5" data-id="element-1832">
                  <div className="relative rounded-xl sm:rounded-2xl overflow-hidden border-2 border-amber-500/30" data-id="element-1833">
                    <img src="https://cdn.magicpatterns.com/uploads/3koR9Um6Z3JLvhRxNTnoti/WEBINAR_BONUS_GUIDE_BOOK.png" alt="Guía Gratis - La Trampa Del 9-5" className="w-full" data-id="element-1834" />
                  </div>
                </div>

                <p className="text-[13px] sm:text-sm md:text-base text-gray-300 leading-relaxed mb-3 sm:mb-4" data-id="element-1835">
                  Esta guía de 30 páginas te va a dar el{' '}
                  <span className="text-white font-bold" data-id="element-1836">CONTEXTO</span> que vas
                  a necesitar para aprovechar al máximo la Masterclass del
                  jueves.
                </p>

                <p className="text-[13px] sm:text-sm md:text-base text-white font-semibold mb-2.5 sm:mb-3" data-id="element-1837">
                  Dentro vas a encontrar:
                </p>

                <ul className="space-y-2 sm:space-y-2.5 mb-5 sm:mb-6" data-id="element-1838">
                  {guideBullets.map((b, i) => <li key={i} className="flex items-start gap-2.5 sm:gap-3" data-id="element-1839">
                      <div className="w-4 h-4 sm:w-5 sm:h-5 rounded-full bg-amber-500/20 border border-amber-500/40 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1840">
                        <CheckCircle2 className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-amber-400" data-id="element-1841" />
                      </div>
                      <span className="text-[13px] sm:text-sm md:text-base text-gray-200 leading-snug" data-id="element-1842">
                        {b}
                      </span>
                    </li>)}
                </ul>

                <div className="flex items-start gap-2.5 sm:gap-3 bg-white/[0.04] border border-white/[0.1] rounded-xl px-3 sm:px-4 py-2.5 sm:py-3 mb-5 sm:mb-6" data-id="element-1843">
                  <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-1844" />
                  <p className="text-[12px] sm:text-xs md:text-sm text-gray-200 leading-snug" data-id="element-1845">
                    Los alumnos que{' '}
                    <span className="font-black text-amber-400" data-id="element-1846">LEEN</span> la
                    guía antes de la Masterclass aprovechan{' '}
                    <span className="font-black" data-id="element-1847">3x más</span> el contenido en
                    vivo. Es 30 páginas — toma 20 minutos.
                  </p>
                </div>

                <a href="https://drive.google.com/file/d/1rxD8Z9ZmJlx6vhjnPVocvWpmsI81QeJb/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-[13px] sm:text-sm md:text-base lg:text-lg uppercase tracking-tight rounded-xl py-3.5 sm:py-4 md:py-5 px-3 sm:px-4 shadow-[0_10px_30px_-10px_rgba(245,158,11,0.6)] hover:shadow-[0_10px_30px_-5px_rgba(245,158,11,0.8)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden flex items-center justify-center gap-2 sm:gap-2.5" data-id="element-1848">
                  <Download className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" data-id="element-1849" />
                  <span data-id="element-1850">Descargar La Guía Gratis</span>
                  <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" data-id="element-1851" />
                  <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-1852" />
                </a>

                <div className="mt-3 sm:mt-4 flex flex-wrap items-center justify-center gap-x-3 sm:gap-x-4 gap-y-1.5 text-[10px] sm:text-[11px] md:text-xs text-gray-400" data-id="element-1853">
                  <span className="flex items-center gap-1" data-id="element-1854">
                    <CheckCircle2 className="w-3 h-3 text-amber-400" data-id="element-1855" /> 30
                    páginas
                  </span>
                  <span className="flex items-center gap-1" data-id="element-1856">
                    <CheckCircle2 className="w-3 h-3 text-amber-400" data-id="element-1857" /> PDF
                  </span>
                  <span className="flex items-center gap-1" data-id="element-1858">
                    <CheckCircle2 className="w-3 h-3 text-amber-400" data-id="element-1859" /> Descarga
                    inmediata
                  </span>
                  <span className="flex items-center gap-1" data-id="element-1860">
                    <CheckCircle2 className="w-3 h-3 text-amber-400" data-id="element-1861" /> En
                    español
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ============ EVENT DETAILS + COUNTDOWN ============ */}
        <section className="mb-12 sm:mb-14 md:mb-20 lg:mb-24 max-w-5xl mx-auto" data-id="element-1862">
          <div className="text-center mb-5 sm:mb-6 md:mb-8" data-id="element-1863">
            <div className="inline-flex items-center gap-1.5 sm:gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-3 sm:px-4 py-1 sm:py-1.5 mb-3 sm:mb-4" data-id="element-1864">
              <Clock className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-amber-400" data-id="element-1865" />
              <span className="text-amber-400 text-[9px] sm:text-[10px] md:text-xs font-black uppercase tracking-[0.16em] sm:tracking-[0.18em] leading-none" data-id="element-1866">
                Cuenta Regresiva
              </span>
            </div>
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-black leading-tight px-1" data-id="element-1867">
              Cuenta Regresiva Para La{' '}
              <span className="text-amber-400" data-id="element-1868">Masterclass</span>
            </h2>
          </div>

          {/* Countdown */}
          <div className="grid grid-cols-4 gap-1.5 sm:gap-2 md:gap-4 max-w-3xl mx-auto mb-6 sm:mb-8 md:mb-10" data-id="element-1869">
            {[{
            label: 'Días',
            value: timeLeft.days
          }, {
            label: 'Horas',
            value: timeLeft.hours
          }, {
            label: 'Min',
            value: timeLeft.minutes
          }, {
            label: 'Seg',
            value: timeLeft.seconds
          }].map(item => <div key={item.label} className="bg-gradient-to-b from-[#0f1b35] to-[#0a1428] border-2 border-amber-500/30 rounded-lg sm:rounded-xl md:rounded-2xl p-2.5 sm:p-3 md:p-5 lg:p-6 text-center shadow-[0_10px_30px_-15px_rgba(245,158,11,0.4)]" data-id="element-1870">
                <div className="text-xl sm:text-2xl md:text-4xl lg:text-5xl font-black text-amber-400 tabular-nums leading-none mb-0.5 sm:mb-1 md:mb-2" data-id="element-1871">
                  {String(item.value).padStart(2, '0')}
                </div>
                <div className="text-[9px] sm:text-[10px] md:text-xs lg:text-sm font-black uppercase tracking-[0.14em] sm:tracking-[0.18em] text-gray-400 leading-none" data-id="element-1872">
                  {item.label}
                </div>
              </div>)}
          </div>

          {/* Event details grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2.5 sm:gap-3 md:gap-4" data-id="element-1873">
            {[{
            icon: Calendar,
            label: 'Fecha',
            value: `Jueves ${thursdayLong}`
          }, {
            icon: Clock,
            label: 'Hora',
            value: '7:00 PM Miami (EST)'
          }, {
            icon: Sparkles,
            label: 'Duración',
            value: '90 min + 30 min Q&A'
          }, {
            icon: Video,
            label: 'Plataforma',
            value: 'Zoom (link en email)'
          }, {
            icon: DollarSign,
            label: 'Costo',
            value: '100% Gratis'
          }, {
            icon: Users,
            label: 'Cupos',
            value: '100 Limitados'
          }].map((d, i) => <div key={i} className="bg-white/[0.03] border border-white/[0.08] rounded-xl px-3 sm:px-4 py-3 sm:py-3.5 flex items-center gap-2.5 sm:gap-3" data-id="element-1874">
                <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-lg bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-1875">
                  <d.icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-amber-400" data-id="element-1876" />
                </div>
                <div className="min-w-0" data-id="element-1877">
                  <div className="text-[9px] sm:text-[10px] md:text-xs font-black uppercase tracking-[0.14em] sm:tracking-[0.15em] text-gray-400 leading-none mb-1" data-id="element-1878">
                    {d.label}
                  </div>
                  <div className="text-[13px] sm:text-sm md:text-base text-white font-bold leading-tight" data-id="element-1879">
                    {d.value}
                  </div>
                </div>
              </div>)}
          </div>
        </section>

        {/* ============ BONUS REINFORCEMENT ============ */}
        <section className="mb-12 sm:mb-14 md:mb-20 lg:mb-24 max-w-5xl mx-auto" data-id="element-1880">
          <div className="relative bg-gradient-to-br from-amber-400 to-amber-500 rounded-2xl md:rounded-3xl p-5 sm:p-6 md:p-10 lg:p-12 text-[#0a1428] overflow-hidden shadow-[0_30px_80px_-30px_rgba(245,158,11,0.55)]" data-id="element-1881">
            <div className="absolute -top-10 -right-10 w-40 h-40 md:w-60 md:h-60 bg-white/10 rounded-full blur-3xl pointer-events-none" data-id="element-1882" />
            <div className="absolute -bottom-10 -left-10 w-40 h-40 md:w-60 md:h-60 bg-[#0a1428]/10 rounded-full blur-3xl pointer-events-none" data-id="element-1883" />

            <div className="relative" data-id="element-1884">
              <div className="inline-flex items-center gap-1.5 sm:gap-2 bg-[#0a1428] text-amber-400 rounded-full px-3 sm:px-4 py-1 sm:py-1.5 mb-4 sm:mb-5" data-id="element-1885">
                <Gift className="w-3 h-3 sm:w-3.5 sm:h-3.5" data-id="element-1886" />
                <span className="text-[9px] sm:text-[10px] md:text-xs font-black uppercase tracking-[0.16em] sm:tracking-[0.18em] leading-none" data-id="element-1887">
                  Bonus Exclusivo Por Asistir En Vivo
                </span>
              </div>

              <h2 className="text-xl sm:text-2xl md:text-4xl lg:text-5xl font-black leading-[1.05] tracking-tight mb-2 sm:mb-3" data-id="element-1888">
                El Código Monroe En Español
                <br data-id="element-1889" />
                <span className="text-[#0a1428]/80 text-lg sm:text-xl md:text-2xl lg:text-3xl block mt-2 sm:mt-3" data-id="element-1890">
                  Las 5 Meditaciones Binaurales Que La CIA Usó Por 30 Años
                </span>
              </h2>

              <p className="text-[13px] sm:text-sm md:text-lg font-bold text-[#0a1428]/85 mb-4 sm:mb-5 max-w-2xl" data-id="element-1891">
                Valor: <span className="line-through opacity-60" data-id="element-1892">$297 USD</span>{' '}
                —{' '}
                <span className="bg-[#0a1428] text-amber-400 px-2 py-0.5 rounded" data-id="element-1893">
                  GRATIS
                </span>{' '}
                solo si asistes EN VIVO al webinar.
              </p>

              <p className="text-[13px] sm:text-sm md:text-base text-[#0a1428]/85 leading-relaxed mb-5 sm:mb-6 max-w-2xl" data-id="element-1894">
                Las únicas meditaciones binaurales en español basadas en la
                tecnología <span className="font-black" data-id="element-1895">Hemi-Sync</span>{' '}
                desarrollada por Bob Monroe — utilizada por la{' '}
                <span className="font-black" data-id="element-1896">CIA en su programa Stargate</span>{' '}
                para entrenar agentes operativos.
                <br className="hidden sm:block" data-id="element-1897" />
                <br className="hidden sm:block" data-id="element-1898" />
                <span className="block mt-3 sm:mt-0" data-id="element-1899">
                  Yo las recreé en español específicamente para los{' '}
                  <span className="font-black" data-id="element-1900">5 momentos críticos</span> del
                  journey de salir del 9-5:
                </span>
              </p>

              <ul className="space-y-2 sm:space-y-2.5 mb-5 sm:mb-6" data-id="element-1901">
                {bonusAudios.map((a, i) => <li key={i} className="flex items-center gap-2.5 sm:gap-3 bg-[#0a1428]/10 backdrop-blur-sm rounded-lg sm:rounded-xl px-3 sm:px-4 py-2.5 sm:py-3" data-id="element-1902">
                    <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-[#0a1428] flex items-center justify-center flex-shrink-0" data-id="element-1903">
                      <Headphones className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-amber-400" data-id="element-1904" />
                    </div>
                    <span className="text-[13px] sm:text-sm md:text-base text-[#0a1428] font-bold leading-snug" data-id="element-1905">
                      {a}
                    </span>
                  </li>)}
              </ul>

              <div className="flex items-start gap-2.5 sm:gap-3 bg-[#0a1428] text-amber-100 rounded-xl px-3 sm:px-4 py-3 sm:py-3.5" data-id="element-1906">
                <AlertTriangle className="w-4 h-4 sm:w-5 sm:h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-1907" />
                <p className="text-[12px] sm:text-xs md:text-sm leading-snug" data-id="element-1908">
                  <span className="font-black text-amber-400" data-id="element-1909">
                    NO se venden por separado.
                  </span>{' '}
                  Solo se entregan EN VIVO al final del webinar.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ============ VISUAL CHECKLIST ============ */}
        <section className="mb-12 sm:mb-14 md:mb-20 lg:mb-24 max-w-4xl mx-auto" data-id="element-1910">
          <div className="text-center mb-5 sm:mb-6 md:mb-8" data-id="element-1911">
            <div className="inline-flex items-center gap-1.5 sm:gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-3 sm:px-4 py-1 sm:py-1.5 mb-3 sm:mb-4" data-id="element-1912">
              <ListChecks className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-amber-400" data-id="element-1913" />
              <span className="text-amber-400 text-[9px] sm:text-[10px] md:text-xs font-black uppercase tracking-[0.16em] sm:tracking-[0.18em] leading-none" data-id="element-1914">
                Checklist
              </span>
            </div>
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-black leading-tight px-1" data-id="element-1915">
              Checklist Para{' '}
              <span className="text-amber-400" data-id="element-1916">Garantizar Tu Lugar</span>
            </h2>
          </div>

          <div className="bg-white/[0.03] border border-white/[0.08] rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-7 lg:p-8" data-id="element-1917">
            <ul className="space-y-2.5 sm:space-y-3 md:space-y-4" data-id="element-1918">
              {checklistItems.map((item, i) => <li key={i} className="flex items-start gap-2.5 sm:gap-3 md:gap-4 bg-white/[0.02] border border-white/[0.06] rounded-xl px-3 sm:px-4 py-3 sm:py-3.5 md:py-4" data-id="element-1919">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 rounded-md border-2 border-amber-500/40 bg-white/[0.05] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1920" />
                  <span className="text-[13px] sm:text-sm md:text-base lg:text-lg text-gray-200 leading-snug" data-id="element-1921">
                    {item}
                  </span>
                </li>)}
            </ul>

            <p className="mt-5 sm:mt-6 text-center text-[13px] sm:text-sm md:text-base lg:text-lg text-gray-300 leading-relaxed px-1" data-id="element-1922">
              Cuando termines estos 3 pasos, estás{' '}
              <span className="text-amber-400 font-black" data-id="element-1923">100% LISTO</span> para
              la Masterclass. Yo me ocupo del resto.
            </p>
          </div>
        </section>

        {/* ============ TESTIMONIALS ============ */}
        <section className="max-w-6xl mx-auto mb-12 sm:mb-14 md:mb-20 lg:mb-24" data-id="element-1924">
          <div className="text-center mb-7 sm:mb-8 md:mb-12 lg:mb-14" data-id="element-1925">
            <div className="inline-flex items-center gap-1.5 sm:gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-3 sm:px-4 py-1 sm:py-1.5 mb-3 sm:mb-4" data-id="element-1926">
              <Star className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-amber-400 fill-amber-400" data-id="element-1927" />
              <span className="text-amber-400 text-[9px] sm:text-[10px] md:text-xs font-black uppercase tracking-[0.16em] sm:tracking-[0.18em] leading-none" data-id="element-1928">
                Resultados Reales
              </span>
            </div>
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-black leading-tight mb-2 sm:mb-3 md:mb-4 px-1" data-id="element-1929">
              Mira Lo Que Están{' '}
              <span className="text-amber-400" data-id="element-1930">Logrando Otros</span>
            </h2>
            <p className="text-[13px] sm:text-sm md:text-base lg:text-lg text-gray-400 max-w-2xl mx-auto px-1" data-id="element-1931">
              Personas como tú que ya están facturando con este sistema.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3.5 sm:gap-4 md:gap-5 lg:gap-6" data-id="element-1932">
            {testimonialVideos.map((v, idx) => <div key={v.id} className="group bg-white/[0.025] border border-white/[0.08] rounded-xl sm:rounded-2xl overflow-hidden flex flex-col hover:border-amber-500/40 hover:bg-white/[0.04] transition-all duration-300" data-id="element-1933">
                <div className="relative bg-[#0f1b35]" data-id="element-1934">
                  <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-1935">
                    <iframe src={`https://player.vimeo.com/video/${v.id}?badge=0&autopause=0&player_id=0&app_id=58479`} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title={`Testimonio ${idx + 1}`} data-id="element-1936" />
                  </div>
                </div>
                <div className="p-3.5 sm:p-4 md:p-5 flex-1 flex items-start gap-2.5 sm:gap-3" data-id="element-1937">
                  <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-lg bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-1938">
                    <span className="text-amber-400 text-[11px] sm:text-xs font-black" data-id="element-1939">
                      {idx + 1}
                    </span>
                  </div>
                  <p className="font-bold text-[13px] sm:text-sm md:text-[15px] text-white leading-snug" data-id="element-1940">
                    {v.title}
                  </p>
                </div>
              </div>)}
          </div>
        </section>

        {/* ============ EMOTIONAL CLOSING ============ */}
        <section className="max-w-3xl mx-auto text-center" data-id="element-1941">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-black leading-tight mb-5 sm:mb-6 md:mb-8 px-1" data-id="element-1942">
            Una Última Cosa
          </h2>

          <div className="space-y-3 sm:space-y-4 md:space-y-5 text-[13px] sm:text-sm md:text-base lg:text-lg text-gray-300 leading-relaxed px-1" data-id="element-1943">
            <p data-id="element-1944">
              Acabas de hacer algo que el{' '}
              <span className="text-white font-bold" data-id="element-1945">95% de las personas</span>{' '}
              NO hace:
            </p>
            <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-black text-amber-400" data-id="element-1946">
              Tomaste acción.
            </p>
            <p data-id="element-1947">Te registraste a la Masterclass.</p>
            <p data-id="element-1948">
              Ahora — para asegurar que la inversión de tu tiempo valga la pena
              — completa los 3 pasos arriba en los próximos{' '}
              <span className="text-white font-bold" data-id="element-1949">2 minutos</span>.
            </p>
            <p className="text-white font-bold" data-id="element-1950">
              Únete al WhatsApp. Abre el email. Descarga la guía.
            </p>
            <p data-id="element-1951">
              Cuando llegue el jueves a las 7 PM, vas a estar 100% listo para
              una de las experiencias más transformadoras que has vivido.
            </p>
            <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white font-black pt-2" data-id="element-1952">
              Te veo el jueves. Pero antes — completá los 3 pasos AHORA.
            </p>
          </div>
        </section>
      </main>

      <Footer data-id="element-1953" />

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowTerms(false)} data-id="element-1954">
          <div className="bg-[#0f1b35] border border-amber-500/30 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative shadow-[0_0_50px_rgba(245,158,11,0.2)]" onClick={e => e.stopPropagation()} data-id="element-1955">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-1956">
              <X className="w-6 h-6" data-id="element-1957" />
            </button>
            <h2 className="text-2xl md:text-3xl font-black mb-6 uppercase tracking-tight" data-id="element-1958">
              Términos y Condiciones
            </h2>
            <div className="text-gray-300 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-1959">
              <p data-id="element-1960">
                Al registrarte y participar en el 48 Hrs AI Cash Machine
                Masterclass, aceptas los siguientes términos y condiciones:
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-1961">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-1962">
                Al acceder y utilizar este sitio web y registrarte para el
                evento, aceptas estar sujeto a estos términos y condiciones,
                todas las leyes y regulaciones aplicables.
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-1963">
                2. Uso del Servicio
              </h3>
              <p data-id="element-1964">
                El contenido proporcionado en el masterclass es solo para fines
                educativos e informativos. No garantizamos resultados
                específicos de ingresos o éxito comercial.
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-1965">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-1966">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de 48 Hrs AI Cash Machine y están protegidos por
                derechos de autor.
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-1967">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-1968">
                48 Hrs AI Cash Machine no será responsable de ningún daño
                directo, indirecto, incidental o consecuente que resulte del uso
                o la imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-1969">
                5. Modificaciones
              </h3>
              <p data-id="element-1970">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento.
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-1971">Contacto</h3>
              <p data-id="element-1972">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-amber-400 hover:text-amber-300" data-id="element-1973">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowPrivacy(false)} data-id="element-1974">
          <div className="bg-[#0f1b35] border border-amber-500/30 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative shadow-[0_0_50px_rgba(245,158,11,0.2)]" onClick={e => e.stopPropagation()} data-id="element-1975">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-1976">
              <X className="w-6 h-6" data-id="element-1977" />
            </button>
            <h2 className="text-2xl md:text-3xl font-black mb-6 uppercase tracking-tight" data-id="element-1978">
              Política de Privacidad
            </h2>
            <div className="text-gray-300 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-1979">
              <p data-id="element-1980">
                En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
                privacidad.
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-1981">
                1. Información que Recopilamos
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-1982">
                <li data-id="element-1983">Nombre y dirección de correo electrónico</li>
                <li data-id="element-1984">Información de registro del evento</li>
                <li data-id="element-1985">Comunicaciones que mantienes con nosotros</li>
              </ul>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-1986">
                2. Uso de la Información
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-1987">
                <li data-id="element-1988">
                  Proporcionar acceso al masterclass y materiales relacionados
                </li>
                <li data-id="element-1989">Enviar comunicaciones sobre el evento</li>
                <li data-id="element-1990">Mejorar nuestros servicios y contenido</li>
                <li data-id="element-1991">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-1992">
                3. Compartir Información
              </h3>
              <p data-id="element-1993">
                No vendemos ni compartimos tu información personal con terceros
                para fines de marketing.
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-1994">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-1995">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas.
              </p>
              <h3 className="text-lg font-black text-white mt-6" data-id="element-1996">Contacto</h3>
              <p data-id="element-1997">
                <a href="mailto:support@truemarketer.com" className="text-amber-400 hover:text-amber-300" data-id="element-1998">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      <WhatsAppButton data-id="element-1999" />
    </div>;
}